"use client";
import { jsxs as c, jsx as m } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import u from "classnames";
const k = d((i, t) => {
  const { open: s, onToggle: e, children: o, summary: r, summaryClassName: a, ...l } = i;
  return /* @__PURE__ */ c("details", { ref: t, open: s, "data-testid": "accordion-item", ...l, children: [
    /* @__PURE__ */ m(
      "summary",
      {
        onClick: (n) => {
          n.preventDefault(), e == null || e(!s);
        },
        className: u(
          a,
          "list-none [&::-webkit-details-marker]:hidden cursor-pointer focus-visible:outline focus-visible:outline-offset focus-visible:outline focus-visible:rounded-sm"
        ),
        children: r
      }
    ),
    o
  ] });
});
export {
  k as default
};
